import React, { useEffect, useLayoutEffect } from 'react'
import classnames from 'classnames'
import bowser from 'bowser'

import {
  VideoPlayerComponent,
  WebinarRoomHeaderComponent,
  WindowTitleComponent,
} from '../../../sharedLegacy/components'
import {
  WebinarAudienceMobileSidebarFeature,
  WebinarAudienceSidebarFeature,
} from '../../../sharedLegacy/features/WebinarAudienceSidebarFeature'
import { WebinarAudienceWaitingRoomComponent } from '..'
import { useSiteQuery } from '../../../global/blocs/useSite'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'
import {
  ensureAudienceLiveStateSubscription,
  useShowAudienceWaitingRoom,
} from '../../useAudienceLiveState'

import './WebinarAudienceRoomContainerComponent.scss'

const WebinarAudienceRoomContainerComponent = () => {
  const { data: liveData } = useLiveDataQuery()
  const { data: site } = useSiteQuery()
  const showAudienceWaitingRoom = useShowAudienceWaitingRoom()

  useLayoutEffect(() => {
    return ensureAudienceLiveStateSubscription()
  }, [])

  useEffect(() => {
    document.body.classList.add('react-audience-room')
  }, [])

  return (
    <div
      className={classnames('webinar-audience-room-container-component', {
        'has-waiting-room': showAudienceWaitingRoom,
      })}
    >
      <WindowTitleComponent
        /* eslint-disable-next-line formatjs/no-literal-string-in-jsx */
        title={`${liveData?.name} - ${site?.site_name}`}
      />
      <div className="webinar-content">
        <div className="webinar-main-content">
          <WebinarRoomHeaderComponent />

          {liveData && (
            <>
              {showAudienceWaitingRoom ? (
                <WebinarAudienceWaitingRoomComponent />
              ) : (
                <VideoPlayerComponent
                  object={liveData}
                  objectType="live"
                  options={{
                    autoPlay: 1,
                    mutedAutoPlay: 1,
                    source: 'site',
                    showLogo: 0,
                    unmuteButtonPosition: 'center',
                    include_actions_p: 0,
                  }}
                />
              )}
            </>
          )}
        </div>
        {liveData && (
          <>
            {!bowser.mobile ? (
              <WebinarAudienceSidebarFeature
                namespace="webinar-audience-sidebar"
                defaultSidebarTab="info"
                /* eslint-disable-next-line jsx-a11y/aria-role */
                role="audience"
                token={liveData.token}
                peopleTabName="Speakers"
                canPostQuestions
              />
            ) : (
              <WebinarAudienceMobileSidebarFeature
                namespace="webinar-audience-sidebar"
                defaultSidebarTab="info"
                /* eslint-disable-next-line jsx-a11y/aria-role */
                role="audience"
                token={liveData.token}
                peopleTabName="Speakers"
                canPostQuestions
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

// eslint-disable-next-line import-x/no-default-export
export default WebinarAudienceRoomContainerComponent

export { WebinarAudienceRoomContainerComponent }
